import * as navigation from 'Navigation';

export default class BoxTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Box',
      closeable: false,
      preferenceKey: 'box',
    };
  }
}
